$(function () {
    $('.slider-simple').each(function () {
        // only create a swiper if there is more than one slide
        if ($(this).find('.swiper-slide').length <= 1) { return; }

        new Swiper(this, {
            lazy: true,
            loop: true,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    });
});